import React from 'react';
import PropTypes from 'prop-types';
import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import { ButtonWithIcon } from '@els/els-react--button';

function PreferredSuppliersHeadingClosed({ onOpen = () => {}, checkedOptionsList }) {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div className="preferred-suppliers-accordion-item__heading rx-accordion-row profile-settings-accordion-row" onClick={onOpen}>
      <span className="profile-settings-accordion-row_label">{ProfileSettingsConfig.Labels.preferredSuppliers}</span>
      <span className="profile-settings-accordion-row_list">
        {checkedOptionsList &&
          checkedOptionsList.map(({ label, name }) => (
            <span key={name} className="preferred-suppliers-item__checked-option  profile-settings-accordion-row_list-tagged">
              {label}
            </span>
          ))}
      </span>
      <div className="preferred-suppliers-accordion-item__controls">
        <ButtonWithIcon
          data-e2e="preferred-suppliers-edit"
          type="link"
          size="small"
          linkIconSize="s"
          sprite="Edit"
          iconOnly
          onClick={() => {}}
          className="preferred-suppliers-accordion-item__edit-button e2e-preferred-suppliers-edit">
          Edit
        </ButtonWithIcon>
      </div>
    </div>
  );
}

PreferredSuppliersHeadingClosed.propTypes = {
  onOpen: PropTypes.func,
  checkedOptionsList: PropTypes.array,
};

export default PreferredSuppliersHeadingClosed;
